module.exports = __webpack_public_path__ + "assets/img/suggest.a291f172.svg";